import Icon from 'veui/components/Icon'
import { IconArrowToTop } from 'dls-icons-vue'

Icon.register('arrow-to-top', IconArrowToTop)
